import { useState } from "react";
import { Music } from "../../Util/Music/Music";
import { HxChildMap } from "../HxMap/HxChildMap";
import { NotesSelect } from "../NoteButtons/NotesSelect";

export function HexKeyHelper(props:{height:number, width:number, radius:number}){
    const [tonic, setTonic] = useState(Music.C)
    const onTonicChange = (noteTonic:number) => {
        setTonic(noteTonic)
    }
    return(
        <div>
            <NotesSelect tonic={tonic} onChange={onTonicChange}/>
            <HxChildMap height={props.height} width={props.width} tonic={tonic} radius={props.radius} hilitedNotes={[]}/>
        </div>
    )   
}